import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { catchError, finalize } from 'rxjs/operators';
import { RegistrationService } from '../../../../shared/services/auth/registration.service';
import { IRegistrationForm } from '../../../../shared/interfaces/auth.interface';
import { verifyCodeErrorMessages } from '../../../model/verify-code-error-messages';
import { AnalyticsFormService } from '../../../../core/services/analytics-form.service';
import { AnalyticsService } from '../../../../core/services/analytics-service';
import { Router } from '@angular/router';
import { SavedUrlService } from '../../../../core/services/saved-url.service';
import { OnboardingService } from '../../../../onboarding/services/onboarding.service';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-step-password',
  templateUrl: './step-password.component.html',
  styleUrls: ['./step-password.component.scss'],
})
export class StepPasswordComponent implements OnInit {

  @Input()
  formGroupName!: string;

  public formName = 'emailGroup';
  public stepForm!: FormGroup;
  public loading = false;
  public errors: string[];
  public submitted = false;
  public passwordVisible: boolean;

  protected readonly errorMessages = verifyCodeErrorMessages;


  constructor(private formGroupDirective: FormGroupDirective, private registrationService: RegistrationService,
              private router: Router,
              private savedUrl: SavedUrlService,
              private analytics: AnalyticsService,
              private onboarding: OnboardingService,
              private analyticsFormService: AnalyticsFormService) {
  }

  ngOnInit(): void {
    this.stepForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
  }

  get password(): FormControl {
    return this.stepForm.get('password') as FormControl;
  }

  public onSubmit() {
    this.loading = true;
    if (this.stepForm.invalid) {
      this.submitted = true;
      this.stepForm.markAllAsTouched();
      return;
    }

    const registerData: IRegistrationForm = this.stepForm.value;

    this.registrationService
      .addPassword(registerData)
      .pipe(
        catchError((errors) => {
          this.errors = errors?.error?.errorCodes;
          this.submitted = true;
          this.password.setErrors({ [errors]: true });
          this.analyticsFormService.sendEventForCaughtError('emailVerificationGroup', this.formName);
          return throwError(() => errors);
        }),
        finalize(() => {
          this.loading = false;
          this.onboarding.init().subscribe();
        }),
      ).subscribe(() => {
      this.trackAnalyticsEvents();

      this.registrationService.clearUtm();
      this.registrationService.addReferralCodeToCookie(registerData.referralCode);

      this.router.navigateByUrl(this.savedUrl.url);
    });
  }

  private trackAnalyticsEvents(): void {
    this.registrationService.trackRegistrationEvent(
      'Customer Email Registration Completed',
      this.formName,
    );
    this.analytics.trackLogin();
    this.analytics.trackWpEventIfEnabled('Register');
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
